import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { ButtonConfig } from 'src/app/domain/registration/models/ButtonConfig';

export const RELATIVE_URL = 'contracts';

export const COLUMNS_TO_SHOW_WEB = [
    'select',
    'name',
    'customer',
    'subscriber',
    'createdAt',
    'status',
    'actions'
];

export const COLUMNS_TO_SHOW_MOBILE = [
    'select',
    'name',
    'customer',
    'status',
    'actions'
];

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
    {
        property: 'name',
        field_type: FieldTypeEnum.LABEL,
        display: 'Nome do Contrato',
        class: 'text-left',
        maxLength: 30,
        formatter: (value: string, row: any) => {
            if (row.contractType === 'customer') return 'CONTRATO CLIENTE';
            if (row.contractType === 'partner') return 'CONTRATO PARCEIRO';
            if (row.contractType === 'standalone') return row.title || '-';
            return '-';
        }
    },
    {
        property: 'customer',
        field_type: FieldTypeEnum.LABEL,
        display: 'Cliente',
        class: 'text-left',
        maxLength: 30,
        formatter: (value: any) => {
            if (!value) return '-';
            return value.companyName || value.name || '-';
        }
    },
    {
        property: 'subscriber',
        field_type: FieldTypeEnum.LABEL,
        display: 'Assinante',
        class: 'text-left',
        maxLength: 30,
        formatter: (value: any) => {
            if (!value) return '-';
            return value || '-';
        }
    },
    {
        property: 'createdAt',
        field_type: FieldTypeEnum.LABEL_DATE,
        display: 'Data de Criação',
        class: 'text-center',
        maxLength: 20
    },
    {
        property: 'status',
        field_type: FieldTypeEnum.LABEL,
        display: 'Status',
        class: 'text-center',
        maxLength: 20,
        formatter: (value: string) => {
            const statusMap: any = {
                'signed': 'ASSINADO',
                'pending': 'PENDENTE',
                'canceled': 'CANCELADO',
                'processing': 'PROCESSANDO',
                'waiting_for_signatories': 'AGUARDANDO ASSINATURAS',
                'waiting_for_signatures': 'AGUARDANDO ASSINATURAS'
            };
            return statusMap[value?.toLowerCase()] || value?.toUpperCase() || 'PENDENTE';
        }
    }
];

export const FILTER_CONFIG: IFieldConfig[] = [
    {
        name: 'customerId',
        label: 'Cliente',
        type: TypeComponentFieldEnum.SELECT,
        options: []
    },
    {
        name: 'status',
        label: 'Status',
        type: TypeComponentFieldEnum.SELECT,
        options: [
            { value: 'pending', label: 'Pendente' },
            { value: 'signed', label: 'Assinado' },
            { value: 'canceled', label: 'Cancelado' }
        ],
        display: 'label'
    },
    {
        name: 'startDate',
        label: 'Data Inicial',
        type: TypeComponentFieldEnum.INPUT_DATE
    },
    {
        name: 'endDate',
        label: 'Data Final',
        type: TypeComponentFieldEnum.INPUT_DATE
    }
];

export const TABLE_BUTTONS: ButtonConfig[] = [
    {
        icon: 'download',
        tooltip: 'Baixar PDF',
        class: '',
        action: 'download'
    },
    {
        icon: 'refresh',
        tooltip: 'Atualizar Status',
        class: '',
        action: 'refresh'
    },
    {
        icon: 'email',
        tooltip: 'Reenviar E-mails',
        class: '',
        action: 'resend'
    },

];

export const CONFIG_VARIABLES_CONTRACT = [

    {
        label: 'Nome do Contratado',
        type: TypeComponentFieldEnum.INPUT,
        name: 'subscriberName',
    },
    {
        label: 'CPF ou CNPJ do Contratado',
        type: TypeComponentFieldEnum.INPUT_CPF_AND_CNPJ,
        name: 'subscriberDocument',
    },
    {
        label: 'Tipo: CPF ou CNPJ',
        type: TypeComponentFieldEnum.SELECT,
        name: 'subscriberDocumentType',
        options: ['CPF', 'CNPJ']
    },
    {
        label: 'Email do Contratado',
        type: TypeComponentFieldEnum.INPUT_EMAIL,
        name: 'subscriberEmail',
    },
    {
        label: 'Telefone do Contratado',
        type: TypeComponentFieldEnum.INPUT_CELLPHONE,
        name: 'subscriberTelephone',
    },
    {
        label: 'Celular do Contratado',
        type: TypeComponentFieldEnum.INPUT_CELLPHONE,
        name: 'subscriberPhone',
    },
    {
        label: 'Endereço do Contratado',
        type: TypeComponentFieldEnum.INPUT,
        name: 'subscriberAddressNumber',
    },
    {
        label: 'Cidade do Contratado',
        type: TypeComponentFieldEnum.INPUT,
        name: 'subscriberCity',
    },
    {
        label: 'Estado do Contratado',
        type: TypeComponentFieldEnum.INPUT,
        name: 'subscriberState',
    },
    {
        label: 'CEP do Contratado',
        type: TypeComponentFieldEnum.INPUT,
        name: 'subscriberCep',
    },
    {
        label: 'Nome do Contratante',
        type: TypeComponentFieldEnum.INPUT,
        name: 'contractorName',
    },
    {
        label: 'CPF ou CNPJ do Contratante',
        type: TypeComponentFieldEnum.INPUT_CPF_AND_CNPJ,
        name: 'contractorDocument',
    },
    {
        label: 'Email do Contratante',
        type: TypeComponentFieldEnum.INPUT,
        name: 'contractorEmail',
    },
    {
        label: 'Telefone do Contratante',
        type: TypeComponentFieldEnum.INPUT,
        name: 'contractorTelephone',
    },
    {
        label: 'Endereço completo do Contratante',
        type: TypeComponentFieldEnum.INPUT,
        name: 'contractorAddress',
    },
    {
        label: 'Cidade do Contratante',
        type: TypeComponentFieldEnum.INPUT,
        name: 'contractorCity',
    },
    {
        label: 'Estado do Contratante',
        type: TypeComponentFieldEnum.INPUT,
        name: 'contractorState',
    },
    {
        label: 'Nome do Contratante no contrato',
        type: TypeComponentFieldEnum.INPUT,
        name: 'contractorNameContract',
    },
    {
        label: 'Documento do Contratante no contrato',
        type: TypeComponentFieldEnum.INPUT_CPF_AND_CNPJ,
        name: 'contractorDocumentContract',
    },
    {
        label: 'Data de vencimento',
        type: TypeComponentFieldEnum.INPUT_DATE,
        name: 'dueDate',
    },
    {
        label: 'Data do primeiro vencimento',
        type: TypeComponentFieldEnum.INPUT_DATE,
        name: 'firstDueDate',
    },

    {
        label: 'Templates Ativos',
        type: TypeComponentFieldEnum.SELECT,
        name: 'templatesActives',
        options: [],
        display: 'name'
    },



];


